"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const hoist_non_react_statics_1 = __importDefault(require("hoist-non-react-statics"));
const react_1 = __importStar(require("react"));
const libs_feature_toggle_1 = require("@hotelplan/libs.feature-toggle");
const gss_context_1 = require("./gss-context");
const fdr_lib_search_state_config_1 = require("@hotelplan/fdr.lib.search.state-config");
const fdr_lib_search_state_util_1 = require("@hotelplan/fdr.lib.search.state-util");
function appWithGss({ gssEndpoint, mapIntermediateGssToAppGss, mapIntermediateFgssToAppFgss, mapAppGssToIntermediateGss, mapAppFgssToIntermediateFgss, featureToggleKey, }) {
    return function (WrappedAppComponent) {
        function AppWithGss(props) {
            var _a;
            const [gssState, setGssState] = (0, react_1.useState)(() => {
                const gssValues = (0, fdr_lib_search_state_util_1.getGSSPageProp)(props.pageProps);
                return {
                    gss: (gssValues === null || gssValues === void 0 ? void 0 : gssValues.gss)
                        ? mapIntermediateGssToAppGss(gssValues.gss)
                        : null,
                    fgss: (gssValues === null || gssValues === void 0 ? void 0 : gssValues.fgss)
                        ? mapIntermediateFgssToAppFgss(gssValues.fgss)
                        : null,
                };
            });
            const featureToggleConfig = (_a = (0, libs_feature_toggle_1.getFeatureTogglePageProp)(props.pageProps)) === null || _a === void 0 ? void 0 : _a.config;
            const gssDisabled = (0, react_1.useMemo)(() => {
                var _a;
                if (!featureToggleConfig || !featureToggleKey)
                    return false;
                return (_a = featureToggleConfig === null || featureToggleConfig === void 0 ? void 0 : featureToggleConfig[featureToggleKey]) === null || _a === void 0 ? void 0 : _a.enabled;
            }, [featureToggleConfig]);
            const currentState = (0, react_1.useRef)(gssState);
            currentState.current = gssState;
            function setGSS(defaultValue, appGss) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (gssDisabled)
                        return;
                    const { gss: currentGss } = currentState.current;
                    const intermediateGss = mapAppGssToIntermediateGss(defaultValue, appGss, currentGss);
                    const nextAppGss = mapIntermediateGssToAppGss(intermediateGss);
                    currentState.current.gss = nextAppGss;
                    setGssState(prevState => {
                        return Object.assign(Object.assign({}, prevState), { gss: nextAppGss });
                    });
                    yield (0, fdr_lib_search_state_util_1.setGSSToServerCookie)(gssEndpoint, fdr_lib_search_state_config_1.GSSType.Hotel, intermediateGss);
                });
            }
            function setFGSS(defaultValue, appFgss) {
                return __awaiter(this, void 0, void 0, function* () {
                    if (!mapAppFgssToIntermediateFgss ||
                        !mapIntermediateFgssToAppFgss ||
                        gssDisabled)
                        return;
                    const { fgss: currentFgss } = currentState.current;
                    const intermediateFgss = mapAppFgssToIntermediateFgss(defaultValue, appFgss, currentFgss);
                    const nextAppFgss = mapIntermediateFgssToAppFgss(intermediateFgss);
                    currentState.current.fgss = nextAppFgss;
                    setGssState(prevState => {
                        return Object.assign(Object.assign({}, prevState), { fgss: nextAppFgss });
                    });
                    yield (0, fdr_lib_search_state_util_1.setGSSToServerCookie)(gssEndpoint, fdr_lib_search_state_config_1.GSSType.Flight, intermediateFgss);
                });
            }
            function resetGSS() {
                return __awaiter(this, void 0, void 0, function* () {
                    setGssState({ gss: null, fgss: null });
                    yield (0, fdr_lib_search_state_util_1.resetGSSServer)(gssEndpoint);
                });
            }
            const resultGSSState = (0, react_1.useMemo)(() => {
                return gssDisabled ? { gss: null, fgss: null } : gssState;
            }, [gssDisabled, gssState]);
            const ctxValue = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, resultGSSState), { setGSS,
                setFGSS,
                resetGSS })), 
            // eslint-disable-next-line react-hooks/exhaustive-deps
            [gssState.gss, gssState.fgss]);
            return (react_1.default.createElement(gss_context_1.GSSContext.Provider, { value: ctxValue },
                react_1.default.createElement(WrappedAppComponent, Object.assign({}, props))));
        }
        return (0, hoist_non_react_statics_1.default)(AppWithGss, WrappedAppComponent);
    };
}
exports.default = appWithGss;
//# sourceMappingURL=app-with-gss.js.map